export const themeData = [
    {
        name: 'Analyzing or Calculating',
        desc: 'A job function where you get to calculate or interpret the meaning of numbers or data.',
        videoID: "68a10de42517393e587d57d6"
    },
    {
        name: 'Artistic Creation',
        desc: 'A job function where you get to be creative from an artistic perspective.',
        videoID: "68a10de42517393e587d57e3"
    },
    {
        name: 'Chronicling or Documenting',
        desc: 'A job function where you get to record and report facts, observations, or conclusions about people, events, places, or processes.',
        videoID: "68a10de42517393e587d57d9"
    },
    {
        name: 'Coaching or Mentoring',
        desc: 'A job function where you get to work with individuals to improve their performance and move them closer to becoming the best they can be in a specific activity or area of their life.',
        videoID: "68a10de4396b42f2f680c7e4"
    },
    {
        name: 'Competition',
        desc: 'A job function where you get to pit your skills or knowledge against those of others in a quest to be the best, because you love to win.',
        videoID: "68a10dee2517393e587d585d"
    },
    {
        name: 'Designing',
        desc: 'A job function where you get to be a creator of things from the perspective of form, function, and beauty.',
        videoID: "68a10dee9deb1fdadc13cabd"
    },
    {
        name: 'Entertaining',
        desc: 'A job function where you get to perform and connect with an audience on an emotional level to make them feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "68a10def9deb1fdadc13cad3"
    },
    {
        name: 'Evaluating or Judging',
        desc: 'A job function that involves a process of evaluating or judging to determine quality, worth, appropriateness, or best option.',
        videoID: "68a10df3396b42f2f680c8cb"
    },
    {
        name: 'Exploring or Adventuring',
        desc: 'A job function where you get to be outdoors and go boldly where few have gone before.',
        videoID: "68a10dfa396b42f2f680c916"
    },
    {
        name: 'Fabricating or Fixing',
        desc: 'A job function where you get to work with your hands and use tools to either build, install, assemble, repair, or restore things.',
        videoID: "68a10dfa396b42f2f680c922"
    },
    {
        name: 'Healing or Caring',
        desc: 'A job function where you get to care for the well-being of people, plants, or animals.',
        videoID: "68a10dfe9deb1fdadc13cb85"
    },
    {
        name: 'Helping or Serving',
        desc: 'A job function where you get to be helpful and supportive in attending to the needs of others.',
        videoID: "68a10e039deb1fdadc13cbd4"
    },
    {
        name: 'Improving or Perfecting',
        desc: 'A job function where your primary focus is on making improvements to products, services, systems, procedures, processes, results, or relationships.',
        videoID: "68a10e049deb1fdadc13cbf2"
    },
    {
        name: 'Investigating or Fact Finding',
        desc: 'A job function that involves the process of fact finding and deductive reasoning to plot strategy or solve mysteries and complex problems.',
        videoID: "68a10e0b396b42f2f680c9e3"
    },
    {
        name: 'Leading or Controlling',
        desc: 'A job function where you get to be in charge and in control of situations and their outcomes.',
        videoID: "68a10e0c396b42f2f680c9fe"
    },
    {
        name: 'Organizing or Coordinating',
        desc: 'A job function where you get to organize and coordinate, itineraries, events, people, projects, or information.',
        videoID: "68a10e10396b42f2f680ca2c"
    },
    {
        name: 'Persuading',
        desc: 'A job function where you get to influence people in terms of their beliefs, attitudes, motivations, or behaviors.',
        videoID: "68a10e15396b42f2f680ca53"
    },
    {
        name: 'Science',
        desc: 'A job function that requires an adherence to the scientific method while conducting experiments to validate a hypothesis.',
        videoID: "68a10e172517393e587d5a41"
    },
    {
        name: 'Socializing',
        desc: 'A job function where you get to work closely with others because you thrive on the camaraderie and sense of community that happens with social interaction.',
        videoID: "68a10e182517393e587d5a58"
    },
    {
        name: 'Storytelling',
        desc: 'A job function where you create and communicate stories that connect on an emotional level to make audiences feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "68a10e1d396b42f2f680cad6"
    },
    {
        name: 'Teaching or Training',
        desc: 'A job function where you get to educate people with knowledge or how-to skills that were previously unknown to them.',
        videoID: "68a10e20396b42f2f680caef"
    }
]